module.exports = __webpack_public_path__ + "img/1542519938.07af3d9a.jpg";